import { render, staticRenderFns } from "./MyBets.vue?vue&type=template&id=28676986&scoped=true&"
import script from "./MyBets.vue?vue&type=script&lang=js&"
export * from "./MyBets.vue?vue&type=script&lang=js&"
import style0 from "./MyBets.vue?vue&type=style&index=0&id=28676986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28676986",
  null
  
)

export default component.exports